import { Spinner } from "@dc/ui/components";

export function AuthLoadingScreen() {
  return (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <Spinner size="lg" />
    </div>
  );
}
